// /home/szymon/kreator2/frontend/src/services/projectApi.js
// v2.1.0 – Dodano obsługę flagi autoCentered
// v2.2.0 - Dodano obsługę foldLine

export async function saveProjectToDb({ url, jsonData, saveType, autoCentered = false, foldLine = null }) {
  // Oczekujemy, że "url" jest już absolutnym adresem,
  // np. "http://100.77.150.90:6001/client/projects/123/history"
  // lub "http://100.77.150.90:6001/admin/projects/123/history"
  console.log('[projectApi] saveProjectToDb called with foldLine:', foldLine); // Dodajemy log
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ 
        saveType, 
        jsonData,
        autoCentered, // Dodajemy flagę autoCentered do danych wysyłanych do serwera
        foldLine // Dodajemy foldLine do danych wysyłanych do serwera
      })
    });

    if (!response.ok) {
      throw new Error('Błąd zapisu projektu w bazie');
    }

    const result = await response.json();
    return result;
  } catch (err) {
    throw err;
  }
}
